// extracted by mini-css-extract-plugin
export default {"header":"Content_header__a-Oqh"};